/* import __COLOCATED_TEMPLATE__ from './item.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { assert } from '@ember/debug';

/**
 Component for each item within a [Components.Nav](Components.Nav.html) component. Have a look there for examples.

 @class NavItem
 @namespace Components
 @extends Component
 @public
 */
let NavItem = (_class = class NavItem extends Component {
  /**
   * Called when clicking the nav item
   *
   * @event onClick
   * @public
   */

  handleClick() {
    this.args.onClick?.();
  }
  constructor(owner, args) {
    super(owner, args);
    let {
      model,
      models
    } = this;
    assert('You cannot pass both `@model` and `@models` to a nav item component!', !model || !models);
  }
}, _applyDecoratedDescriptor(_class.prototype, "handleClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleClick"), _class.prototype), _class);
export { NavItem as default };